import React, { useState } from 'react'
import MainParticular from './MainParticulars/Main'
import LoanJourneyDashboard from './MainParticulars/Chart/Dashboard';
export default function Main({ admin, allDetail, type="loan" }) {
  const [tab, setTab] = useState("particular")

  const handleTabs = (type) => {
    setTab(type)
  }
  return (
    <>
      {tab == "particular" ? <MainParticular handleTabs={handleTabs} admin={admin} allDetail={allDetail} type={type} /> : <LoanJourneyDashboard handleTabs={handleTabs}/>}
    </>
  )
}
